<template>
    <div class="welcome-container text-left white--text py-2">
      <!-- Main Header -->
      <div class="d-flex align-center mb-3">
        <v-avatar color="rgba(255, 255, 255, 0.2)" size="54" class="mr-3 elevation-2">
          <v-icon color="amber lighten-3" large>mdi-scale-balance</v-icon>
        </v-avatar>
        <div>
          <h5 v-if="isMobile" class="text-h5 font-weight-black text-uppercase tracking-wide amber--text text--lighten-3 mb-0">
            Legal Billing
          </h5>
          <h5 v-else class="text-h5 font-weight-black text-uppercase tracking-wide amber--text text--lighten-3 mb-0">
            Legal Case Billing
          </h5>
          <span class="caption text-uppercase font-weight-medium grey--text text--lighten-2">
            Smart Billing & Invoicing for Attorneys
          </span>
        </div>
      </div>
  
      <!-- <p class="text-subtitle-2 font-weight-light grey--text text--lighten-3 mb-4 line-height-relaxed">
        A comprehensive fee-earning and legal billing solution tailored for law practices to manage matters, trust accounts, court tariffs, and time tracking.
      </p> -->
  
      <!-- Key Modules Grid -->
      <v-row class="mb-4" dense>
        <v-col v-for="(module, index) in modules" :key="index" cols="12" sm="6">
          <v-card flat class="glass-card fill-height pa-3 rounded-lg">
            <div class="d-flex align-center">
              <v-icon color="amber lighten-3" class="mr-2">{{ module.icon }}</v-icon>
              <div>
                <div class="body-2 font-weight-bold white--text">{{ module.title }}</div>
                <div class="caption grey--text text--lighten-2">{{ module.description }}</div>
              </div>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6">
          <v-btn 
            block
            x-large
            elevation="0"
            class="glass-card custom-btn-card text-none pa-3 rounded-lg text-left"
            @click="gotoDirectory()"
          >
            <div class="d-flex align-center w-100">
              <v-icon color="yellow lighten-3" class="mr-2 flex-shrink-0">mdi-database</v-icon>
              <div class="text-truncate">
                <div class="body-2 font-weight-bold yellow--text text-wrap">Directory of Law Firms</div>
                <div class="caption yellow--text text--lighten-4 text-wrap">Law Firms, Attorneys & Contacts
                  <v-icon right dark>mdi-arrow-right</v-icon>
                </div>
              </div>
            </div>
          </v-btn>
        </v-col>
      </v-row>
  
      <!-- Tech Support & Creator Info -->
      <v-card flat class="glass-card pa-3 rounded-lg mb-4">
        <div class="d-flex align-center justify-space-between flex-wrap ga-2">
          <!-- Branding -->
          <div class="d-flex align-center">
            <v-avatar size="32" class="mr-2 pa-1" color="white">
              <img 
                :src="logoSrcDark" 
                alt="Baron IT Solutions Logo" 
                @error="imgError = true"
                v-if="!imgError"
              />
              <v-icon v-else color="primary" small>mdi-gavel</v-icon>
            </v-avatar>
            <div>
              <div class="caption grey--text text--lighten-2">Created by</div>
              <div class="caption font-weight-bold white--text">Baron IT Solutions</div>
            </div>
          </div>
  
          <v-divider vertical class="mx-2 hidden-xs-only" style="border-color: rgba(255,255,255,0.2)"></v-divider>
  
          <!-- Tech Support Links -->
          <div class="d-flex align-center flex-wrap ga-1">
            <v-btn 
              small 
              text 
              dark 
              class="text-none px-2" 
              href="https://wa.me/27814826615" 
              target="_blank"
            >
              <v-icon small color="green lighten-2" class="mr-1">mdi-whatsapp</v-icon>
              081 482 6615
            </v-btn>
  
            <v-btn 
              small 
              text 
              dark 
              class="text-none px-2" 
              href="mailto:mail@baronitsolutions.co.za"
            >
              <v-icon small color="amber lighten-3" class="mr-1">mdi-email-outline</v-icon>
              Support
            </v-btn>
          </div>
        </div>
      </v-card>
  
      <!-- Mobile Scroll Button -->
      <div v-if="$vuetify.breakpoint.smAndDown" class="text-center pt-2">
        <v-btn
          outlined
          dark
          block
          large
          rounded
          class="amber--text text--lighten-4 border-amber"
          @click="$emit('scroll-to-login')"
        >
        <v-icon left>mdi-arrow-down</v-icon>
           Register | Login
          <v-icon right>mdi-arrow-down</v-icon>
        </v-btn>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "LegalBillingWelcome",
    computed:{
      isMobile(){
        return this.$store.getters.isMobile
      }
    },
    data() {
      return {
        imgError: false,
        logoSrc: require("@/assets/logos/baron-it-logo.png"),
        logoSrcDark: require("@/assets/logos/baron-it-logo-dark.jpeg"),
        modules: [
        {
            icon: "mdi-briefcase-check-outline",
            title: "Matter Management",
            description: "Full case history & ledgers"
          },
          {
            icon: "mdi-timer-outline",
            title: "Client Billing & Invoicing",
            description: "Precision time & activity tracking"
          },
          // {
          //   icon: "mdi-bank-outline",
          //   title: "Trust Accounting",
          //   description: "Compliant legal accounting"
          // },
          {
            icon: "mdi-file-document-multiple",
            title: "Documents Management",
            description: "Manage case documents digitally"
          },
          
        ]
      };
    },
    methods:{
      gotoDirectory(){
        const category =   {
          label: "Attorneys & Law Firms",
          icon: "mdi-scale-balance",
          slug: "attorneys",
          route: "attorneys",
          industries: ["Legal Practice","Legal"],
          gradient: "linear-gradient(135deg, #332421 0%, #332119 100%)",
          description:
            "Find verified attorneys, advocates, and law firms sorted by expertise, province, and court jurisdiction."
        };

        this.$router.push({ name: "directory-listings", params: {category} });
      }
    }
  };
  </script>
  
  <style scoped>
  .welcome-container {
    max-width: 520px;
    margin: 0 auto;
  }
  
  .glass-card {
    background: rgba(255, 255, 255, 0.08) !important;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.15) !important;
  }
  
  .tracking-wide {
    letter-spacing: 1.5px !important;
  }
  
  .line-height-relaxed {
    line-height: 1.6;
  }
  
  .ga-1 {
    gap: 4px;
  }
  .ga-2 {
    gap: 8px;
  }
  
  .border-amber {
    border-color: rgba(255, 213, 79, 0.5) !important;
  }

  
  /* Ensures the button behaves visually like a v-card container */
.custom-btn-card {
  height: 100% !important;
  min-height: 100% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  white-space: normal !important;
}

/* Fixes default Vuetify button inner content flex behavior */
.custom-btn-card ::v-deep .v-btn__content {
  width: 100%;
  justify-content: flex-start;
  white-space: normal;
  text-align: left;
}

.w-100 {
  width: 100%;
}
  </style>